/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RentalCarCoverage,
  VehicleBookingDetails,
  VehicleBookingDisplays,
  VehicleBookingDisplaysRequest,
  VehicleBookingRequest,
  VehicleBookingResponse,
  VehicleBookingStatuses,
  VehicleBookingStatusesRequest,
  VehicleCancelResponse,
  VehicleDetails,
  VehicleRecommendations,
  VehicleSearchRequest,
  VehicleSearchResponse,
} from '../models/index';
import {
    RentalCarCoverageFromJSON,
    RentalCarCoverageToJSON,
    VehicleBookingDetailsFromJSON,
    VehicleBookingDetailsToJSON,
    VehicleBookingDisplaysFromJSON,
    VehicleBookingDisplaysToJSON,
    VehicleBookingDisplaysRequestFromJSON,
    VehicleBookingDisplaysRequestToJSON,
    VehicleBookingRequestFromJSON,
    VehicleBookingRequestToJSON,
    VehicleBookingResponseFromJSON,
    VehicleBookingResponseToJSON,
    VehicleBookingStatusesFromJSON,
    VehicleBookingStatusesToJSON,
    VehicleBookingStatusesRequestFromJSON,
    VehicleBookingStatusesRequestToJSON,
    VehicleCancelResponseFromJSON,
    VehicleCancelResponseToJSON,
    VehicleDetailsFromJSON,
    VehicleDetailsToJSON,
    VehicleRecommendationsFromJSON,
    VehicleRecommendationsToJSON,
    VehicleSearchRequestFromJSON,
    VehicleSearchRequestToJSON,
    VehicleSearchResponseFromJSON,
    VehicleSearchResponseToJSON,
} from '../models/index';

export interface CreditCardCoverageGetRequest {
    creditCardProductName?: string;
    cardNumberBin?: string;
    cardProvider?: CreditCardCoverageGetCardProviderEnum;
}

export interface VehicleBookPostRequest {
    vehicleBookingRequest: VehicleBookingRequest;
}

export interface VehicleBookingCoverageGetRequest {
    gondolaBookingId: string;
}

export interface VehicleBookingGetRequest {
    gondolaBookingId: string;
}

export interface VehicleBookingIdCancelPostRequest {
    bookingId: string;
    suppressUserEmail?: boolean;
}

export interface VehicleBookingsDisplayPostRequest {
    vehicleBookingDisplaysRequest: VehicleBookingDisplaysRequest;
}

export interface VehicleBookingsStatusesPostRequest {
    vehicleBookingStatusesRequest: VehicleBookingStatusesRequest;
}

export interface VehicleRecommendationsBookingIdGetRequest {
    bookingId: string;
}

export interface VehicleSearchPostRequest {
    vehicleSearchRequest: VehicleSearchRequest;
}

export interface VehicleSearchSearchIdGetRequest {
    searchId: string;
}

export interface VehicleSearchSearchIdStreamGetRequest {
    searchId: string;
}

export interface VehicleVendorCodeRateCodeDetailsGetRequest {
    vendorCode: string;
    rateCode: string;
    searchId: string;
    pickupLocation?: string;
    acrissCode?: string;
    vendorLocationId?: string;
    deskKind?: string;
    selectedRateType?: string;
}

/**
 * 
 */
export class VehiclesApi extends runtime.BaseAPI {

    /**
     * Returns rental car CDW/LDW coverage information. Provide either credit_card_product_name (for MX-synced cards) or card_number_bin + card_provider (for non-MX cards using BIN-based tier detection).
     */
    async creditCardCoverageGetRaw(requestParameters: CreditCardCoverageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RentalCarCoverage>> {
        const queryParameters: any = {};

        if (requestParameters['creditCardProductName'] != null) {
            queryParameters['credit_card_product_name'] = requestParameters['creditCardProductName'];
        }

        if (requestParameters['cardNumberBin'] != null) {
            queryParameters['card_number_bin'] = requestParameters['cardNumberBin'];
        }

        if (requestParameters['cardProvider'] != null) {
            queryParameters['card_provider'] = requestParameters['cardProvider'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/credit-card-coverage`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RentalCarCoverageFromJSON(jsonValue));
    }

    /**
     * Returns rental car CDW/LDW coverage information. Provide either credit_card_product_name (for MX-synced cards) or card_number_bin + card_provider (for non-MX cards using BIN-based tier detection).
     */
    async creditCardCoverageGet(requestParameters: CreditCardCoverageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RentalCarCoverage> {
        const response = await this.creditCardCoverageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Book a rental vehicle
     */
    async vehicleBookPostRaw(requestParameters: VehicleBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleBookingResponse>> {
        if (requestParameters['vehicleBookingRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleBookingRequest',
                'Required parameter "vehicleBookingRequest" was null or undefined when calling vehicleBookPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/book`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleBookingRequestToJSON(requestParameters['vehicleBookingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleBookingResponseFromJSON(jsonValue));
    }

    /**
     * Book a rental vehicle
     */
    async vehicleBookPost(requestParameters: VehicleBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleBookingResponse> {
        const response = await this.vehicleBookPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the rental car coverage that was stored at booking time.
     */
    async vehicleBookingCoverageGetRaw(requestParameters: VehicleBookingCoverageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RentalCarCoverage>> {
        if (requestParameters['gondolaBookingId'] == null) {
            throw new runtime.RequiredError(
                'gondolaBookingId',
                'Required parameter "gondolaBookingId" was null or undefined when calling vehicleBookingCoverageGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle-booking/{gondola_booking_id}/coverage`;
        urlPath = urlPath.replace(`{${"gondola_booking_id"}}`, encodeURIComponent(String(requestParameters['gondolaBookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RentalCarCoverageFromJSON(jsonValue));
    }

    /**
     * Returns the rental car coverage that was stored at booking time.
     */
    async vehicleBookingCoverageGet(requestParameters: VehicleBookingCoverageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RentalCarCoverage> {
        const response = await this.vehicleBookingCoverageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details of an existing vehicle booking by its Gondola booking ID.
     */
    async vehicleBookingGetRaw(requestParameters: VehicleBookingGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleBookingDetails>> {
        if (requestParameters['gondolaBookingId'] == null) {
            throw new runtime.RequiredError(
                'gondolaBookingId',
                'Required parameter "gondolaBookingId" was null or undefined when calling vehicleBookingGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle-booking/{gondola_booking_id}`;
        urlPath = urlPath.replace(`{${"gondola_booking_id"}}`, encodeURIComponent(String(requestParameters['gondolaBookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleBookingDetailsFromJSON(jsonValue));
    }

    /**
     * Get details of an existing vehicle booking by its Gondola booking ID.
     */
    async vehicleBookingGet(requestParameters: VehicleBookingGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleBookingDetails> {
        const response = await this.vehicleBookingGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a vehicle booking
     */
    async vehicleBookingIdCancelPostRaw(requestParameters: VehicleBookingIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleCancelResponse>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling vehicleBookingIdCancelPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['suppressUserEmail'] != null) {
            queryParameters['suppress_user_email'] = requestParameters['suppressUserEmail'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/{booking_id}/cancel`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleCancelResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a vehicle booking
     */
    async vehicleBookingIdCancelPost(requestParameters: VehicleBookingIdCancelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleCancelResponse> {
        const response = await this.vehicleBookingIdCancelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get vehicle booking display details (vendor, class, pickup/dropoff, confirmation) for a list of VehicleBooking ids. Used to enrich rewards-ledger rows whose booking_id is a VehicleBooking PK.
     */
    async vehicleBookingsDisplayPostRaw(requestParameters: VehicleBookingsDisplayPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleBookingDisplays>> {
        if (requestParameters['vehicleBookingDisplaysRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleBookingDisplaysRequest',
                'Required parameter "vehicleBookingDisplaysRequest" was null or undefined when calling vehicleBookingsDisplayPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle_bookings/display`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleBookingDisplaysRequestToJSON(requestParameters['vehicleBookingDisplaysRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleBookingDisplaysFromJSON(jsonValue));
    }

    /**
     * Get vehicle booking display details (vendor, class, pickup/dropoff, confirmation) for a list of VehicleBooking ids. Used to enrich rewards-ledger rows whose booking_id is a VehicleBooking PK.
     */
    async vehicleBookingsDisplayPost(requestParameters: VehicleBookingsDisplayPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleBookingDisplays> {
        const response = await this.vehicleBookingsDisplayPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get vehicle booking statuses (completed = confirmed + past dropoff, cancelled = cancelled). Resolves ids against vehicle_bookings, distinct from the hotel /bookings/statuses endpoint.
     */
    async vehicleBookingsStatusesPostRaw(requestParameters: VehicleBookingsStatusesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleBookingStatuses>> {
        if (requestParameters['vehicleBookingStatusesRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleBookingStatusesRequest',
                'Required parameter "vehicleBookingStatusesRequest" was null or undefined when calling vehicleBookingsStatusesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle_bookings/statuses`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleBookingStatusesRequestToJSON(requestParameters['vehicleBookingStatusesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleBookingStatusesFromJSON(jsonValue));
    }

    /**
     * Get vehicle booking statuses (completed = confirmed + past dropoff, cancelled = cancelled). Resolves ids against vehicle_bookings, distinct from the hotel /bookings/statuses endpoint.
     */
    async vehicleBookingsStatusesPost(requestParameters: VehicleBookingsStatusesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleBookingStatuses> {
        const response = await this.vehicleBookingsStatusesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get rental car recommendations for a hotel booking (cross-sell)
     */
    async vehicleRecommendationsBookingIdGetRaw(requestParameters: VehicleRecommendationsBookingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleRecommendations>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling vehicleRecommendationsBookingIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/recommendations/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleRecommendationsFromJSON(jsonValue));
    }

    /**
     * Get rental car recommendations for a hotel booking (cross-sell)
     */
    async vehicleRecommendationsBookingIdGet(requestParameters: VehicleRecommendationsBookingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleRecommendations> {
        const response = await this.vehicleRecommendationsBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for available rental vehicles at a location
     */
    async vehicleSearchPostRaw(requestParameters: VehicleSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleSearchResponse>> {
        if (requestParameters['vehicleSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleSearchRequest',
                'Required parameter "vehicleSearchRequest" was null or undefined when calling vehicleSearchPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleSearchRequestToJSON(requestParameters['vehicleSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for available rental vehicles at a location
     */
    async vehicleSearchPost(requestParameters: VehicleSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleSearchResponse> {
        const response = await this.vehicleSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get vehicle search results by search ID (polling endpoint)
     */
    async vehicleSearchSearchIdGetRaw(requestParameters: VehicleSearchSearchIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleSearchResponse>> {
        if (requestParameters['searchId'] == null) {
            throw new runtime.RequiredError(
                'searchId',
                'Required parameter "searchId" was null or undefined when calling vehicleSearchSearchIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/search/{search_id}`;
        urlPath = urlPath.replace(`{${"search_id"}}`, encodeURIComponent(String(requestParameters['searchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleSearchResponseFromJSON(jsonValue));
    }

    /**
     * Get vehicle search results by search ID (polling endpoint)
     */
    async vehicleSearchSearchIdGet(requestParameters: VehicleSearchSearchIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleSearchResponse> {
        const response = await this.vehicleSearchSearchIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Server-sent-events stream of vehicle search results. Replaces client polling of `GET /vehicle/search/{search_id}`: instead of re-fetching the whole session, the server pushes per-batch events as the search completes. Emits `batch_start` once, then one `vehicles` event per completed batch, then a terminal `complete` or `error` event. Mirrors `GET /v2/search/{search_session_id}/stream` on the hotel side. 
     */
    async vehicleSearchSearchIdStreamGetRaw(requestParameters: VehicleSearchSearchIdStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['searchId'] == null) {
            throw new runtime.RequiredError(
                'searchId',
                'Required parameter "searchId" was null or undefined when calling vehicleSearchSearchIdStreamGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/search/{search_id}/stream`;
        urlPath = urlPath.replace(`{${"search_id"}}`, encodeURIComponent(String(requestParameters['searchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Server-sent-events stream of vehicle search results. Replaces client polling of `GET /vehicle/search/{search_id}`: instead of re-fetching the whole session, the server pushes per-batch events as the search completes. Emits `batch_start` once, then one `vehicles` event per completed batch, then a terminal `complete` or `error` event. Mirrors `GET /v2/search/{search_session_id}/stream` on the hotel side. 
     */
    async vehicleSearchSearchIdStreamGet(requestParameters: VehicleSearchSearchIdStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.vehicleSearchSearchIdStreamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get vehicle details including extras, insurance, and rules
     */
    async vehicleVendorCodeRateCodeDetailsGetRaw(requestParameters: VehicleVendorCodeRateCodeDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDetails>> {
        if (requestParameters['vendorCode'] == null) {
            throw new runtime.RequiredError(
                'vendorCode',
                'Required parameter "vendorCode" was null or undefined when calling vehicleVendorCodeRateCodeDetailsGet().'
            );
        }

        if (requestParameters['rateCode'] == null) {
            throw new runtime.RequiredError(
                'rateCode',
                'Required parameter "rateCode" was null or undefined when calling vehicleVendorCodeRateCodeDetailsGet().'
            );
        }

        if (requestParameters['searchId'] == null) {
            throw new runtime.RequiredError(
                'searchId',
                'Required parameter "searchId" was null or undefined when calling vehicleVendorCodeRateCodeDetailsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchId'] != null) {
            queryParameters['search_id'] = requestParameters['searchId'];
        }

        if (requestParameters['pickupLocation'] != null) {
            queryParameters['pickup_location'] = requestParameters['pickupLocation'];
        }

        if (requestParameters['acrissCode'] != null) {
            queryParameters['acriss_code'] = requestParameters['acrissCode'];
        }

        if (requestParameters['vendorLocationId'] != null) {
            queryParameters['vendor_location_id'] = requestParameters['vendorLocationId'];
        }

        if (requestParameters['deskKind'] != null) {
            queryParameters['desk_kind'] = requestParameters['deskKind'];
        }

        if (requestParameters['selectedRateType'] != null) {
            queryParameters['selected_rate_type'] = requestParameters['selectedRateType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/vehicle/{vendor_code}/{rate_code}/details`;
        urlPath = urlPath.replace(`{${"vendor_code"}}`, encodeURIComponent(String(requestParameters['vendorCode'])));
        urlPath = urlPath.replace(`{${"rate_code"}}`, encodeURIComponent(String(requestParameters['rateCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDetailsFromJSON(jsonValue));
    }

    /**
     * Get vehicle details including extras, insurance, and rules
     */
    async vehicleVendorCodeRateCodeDetailsGet(requestParameters: VehicleVendorCodeRateCodeDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDetails> {
        const response = await this.vehicleVendorCodeRateCodeDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreditCardCoverageGetCardProviderEnum = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    Amex: 'amex',
    Discover: 'discover'
} as const;
export type CreditCardCoverageGetCardProviderEnum = typeof CreditCardCoverageGetCardProviderEnum[keyof typeof CreditCardCoverageGetCardProviderEnum];
